module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-lock-open-596f7c4ae92edb6953ead045f4c6346d.png";